import { useEffect, useRef } from "react";

export function useInfiniteScroll(callback) {
  const observerRef = useRef(null); // Ref to the element being watched

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          callback();
        }
      },
      {
        threshold: 0.1, // Fires when whole element is visible
      }
    );

    const current = observerRef.current;
    if (current) observer.observe(current);

    return () => {
      if (current) observer.unobserve(current); // cleanup
    };
  }, [callback]);

  return observerRef; // ref to attach to div in component
}
